import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import "./IndexProveedorComercializadorLealtad.css";
import MenuProvComercializadorLealtad from "../componentsProveedorComercializadorLealtad/MenuLeftProveedorComercializadorLealtad/menuLeftProvLealtad";
import MenuPhoneProvComerLealtad from "../componentsProveedorComercializadorLealtad/MenuLeftPhoneProvComercializadorLealtad/menuLeftPhoneProvLealtad";
import ProfileprovUser from "../profileprovUserComercializador/profileprovUser";
import TermsConditionIndexLealtad from "../TermsConditionIndexLealtad/TermsConditionIndexLealtad";
import Provdocumentation from "../provdomuentationComercializadorLealtad/provdocumentationLealtad";
import UpdateBillLealtad from "../updateBillLealtad/updateBillLealtad";
import ChangePasswordLealtad from "../ChangePasswordLealtad/ChangePasswordLealtad";
import WelcomeLealtad from "../welcomeLealtad/welcomeLealtad";
import AlertProvLealtad from "../AlertProvLealtad/AlertProvLealtad";
import AlertPercentageLealtad from "../AlertPercentageLealtad/AlertPercentageLealtad";

import jurada from "../../assets/pdf/declaracion_jurada_LEALTAD.pdf";
import conducta from "../../assets/pdf/Codigo_conducta_LEALTAD.pdf";

const IndexProveedorComercializador = () => {
  const [viewSeeProv, setViewPageProv] = useState(null);
  const [alertid, setAlertId] = useState(null);
  const location = useLocation();
  let data = location.state;
  const tipeviewSee = (datos) => {
    setViewPageProv(datos);
  };

  if (!data) {
    const storedData = sessionStorage.getItem("Data");
    if (storedData) {
      data = JSON.parse(storedData);
    }
  } else {
    // Almacena los datos en sessionStorage si están disponibles
    sessionStorage.setItem("Data", JSON.stringify(data));
  }

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          process.env.REACT_APP_ALERTS_SUPPLIER_LEALTAD,
        );

        if (response.data.length > 0 && response.data.includes(data.id)) {
          setAlertId(data.id);
        }
      } catch (error) {
        console.error("Error al obtener los datos:", error);
      }
    };

    fetchData();
  }, [data.id]);

  useEffect(() => {
    Swal.fire({
      title: "Cobro de comisiones",
      text: "Estimado comercializador, le pedimos por favor que descargue los siguientes documentos para poder cobrar las comisiones. Una vez completados, deberá enviarlos a lealtadam@gmail.com.",
      icon: "info",
      showCancelButton: true,
      confirmButtonText: "Descargar documentos",
      cancelButtonText: "Cerrar",
    }).then((result) => {
      if (result.isConfirmed) {
        const archivos = [
          {
            ruta: jurada,
            nombre: "Anexo I declaracion jurada - LEALTAD.pdf",
          },
          {
            ruta: conducta,
            nombre: "Codigo de conducta - LEALTAD.pdf",
          },
        ];

        archivos.forEach((archivo) => {
          const link = document.createElement("a");

          link.href = archivo.ruta;
          link.download = archivo.nombre;

          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        });
      }
    });
  }, []);

  return (
    <div className="boxprovmenuallmenulealtad">
      <MenuProvComercializadorLealtad viewSee={tipeviewSee} />
      <MenuPhoneProvComerLealtad viewSee={tipeviewSee} />

      {alertid !== null ? <AlertProvLealtad /> : null}
      <AlertPercentageLealtad />

      {viewSeeProv === "Perfil" ? <ProfileprovUser /> : null}
      {viewSeeProv === "Convenio" ? (
        <TermsConditionIndexLealtad data={data} />
      ) : null}
      {viewSeeProv === "Factura" ? <UpdateBillLealtad data={data} /> : null}
      {viewSeeProv === "Documentacion" ? (
        <Provdocumentation data={data} />
      ) : null}
      {viewSeeProv === "Contraseña" ? (
        <ChangePasswordLealtad data={data} />
      ) : null}
      {viewSeeProv === null && <WelcomeLealtad data={data} />}
    </div>
  );
};

export default IndexProveedorComercializador;
